module.exports = __webpack_public_path__ + "img/10-half-sm.0faf3bec.jpg";